(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Orbit3dDisplay", [], factory);
	else if(typeof exports === 'object')
		exports["Orbit3dDisplay"] = factory();
	else
		root["Orbit3dDisplay"] = factory();
})(window, function() {
return 